import { WEED_REGISTRY } from '@/data/weed-registry'

const weedTerms = Array.from(new Set(WEED_REGISTRY.flatMap((weed) => [
  weed.displayName,
  ...weed.aliases,
]))).map((term) => term.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim())

export function isWeedPost(slug?: string, category?: string, tags?: string[]): boolean {
  const hay = [slug, category, ...(tags ?? [])]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
  if (!hay || /\bweed and feed\b/.test(hay)) return false
  if (/\bweed control\b/.test(hay)) return true
  return weedTerms.some((term) => new RegExp(`\\b${term.replace(/\s+/g, '\\s+')}\\b`).test(hay))
}

export function weedIdentifierHref(source: string, guide?: string): string {
  const params = new URLSearchParams({ source })
  if (guide) params.set('guide', guide)
  return `/weed-identifier?${params.toString()}`
}

export const WEED_IDENTIFIER_CTA = {
  label: 'Identify this weed',
  tagline: 'Upload a photo, see the visual evidence, and get a safer next step.',
  location: {
    inline: 'blog_inline_weed_identifier',
    sidebar: 'content_sidebar_weed_identifier',
    postRead: 'blog_post_read_weed_identifier',
    guide: 'weed_guide_identifier',
    footer: 'footer_weed_identifier',
  },
} as const
